<template>
  <div class="checkIn full-height checkIn-banner ">
    <ld-header
      @click-left="back"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
      <!-- <trip-type slot="right" /> -->
    </ld-header>

    <div class="list">
      <div class="top">
        &nbsp;
      </div>
      <!-- <span class="font16 font-bold">优先值机</span> -->
      <div class="box">
        <van-cell>航班信息</van-cell>
        <van-field
          label="航班号"
          placeholder="请输入航班号"
          maxlength="10"
          v-model="flightNo"
          @click.stop="toggle('queryFlights')"
          readonly
        >
          <template #button>
            <span
              class="dBtn main-color"
              @click.stop="myFlight('myFlights')"
            >
              {{ $t('J052','我的航班') }}
            </span>
          </template>
        </van-field>
        <van-field
          v-show="serverAirportNameStr"
          label="服务机场"
          placeholder="起飞机场"
          v-model="serverAirportNameStr"
          readonly
        />
        <van-field
          label="起飞日期"
          v-model="dateStr"
          is-link
          @click="showDate"
          input-align="left"
          :readonly="true"
        />
      </div>

      <div class="box">
        <van-cell>座位偏好</van-cell>
        <van-cell>
          <div class="box">
            排数偏好
          </div>
          <span
            v-for="(info,index) in seatTypeData"
            :key="index"
          >
            <van-tag
              :type="info.checked?'primary':'default'"
              :text-color="info.checked?'mian-color':''"
              round
              size="large"
              @click="selected('seatTypeData',index)"
            >
              {{ info.name }}
            </van-tag>&nbsp;
          </span>
        </van-cell>
        <van-cell>
          <div class="box">
            横向偏好
          </div>
          <span
            v-for="(info1,index2) in seatTypeData1"
            :key="index2"
          >
            <van-tag
              :type="info1.checked?'primary':'default'"
              :text-color="info1.checked?'mian-color':''"
              round
              size="large"
              @click="selected('seatTypeData1',index2)"
            >
              {{ info1.name }}
            </van-tag>&nbsp;
          </span>
        </van-cell>
      </div>
      <div class="box">
        <van-cell>服务介绍</van-cell>
        <van-field
          type="textarea"
          readonly
          autosize
          v-model="productInfo.serviceIntroduce"
        />
      </div>
    </div>
    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col
          span="22"
        >
          <ld-button
            main
            size="md"
            @click="book"
          >
            预约
            <span
              class="font-lg text-right text-space-1"
              v-show="productInfo.salesPrice"
            >
              ( <span class="font10">&yen;</span>
              <span class="font16 ">{{ productInfo.salesPrice }}</span> )
            </span>
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!--  -->
    <!--航班列表  -->
    <car-flights
      ref="myFlights"
      :data="myFlightData"
      @selected="getFlight"
      :use-type="myflt"
    />

    <!-- 查询航班  -->
    <query-flights
      ref="queryFlights"
      @selected="queryFlights"
      @getParams="getFlight"
      :show-tab="true"
    />

    <!-- <van-popup
      :lock-scroll="true"
      v-model="showDate"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-datetime-picker
        v-model="expiryDate"
        type="datetime"
        :min-date="minDate"
        @cancel="showDate != false"
        @confirm="getDate"
      />
    </van-popup> -->

    <ld-calendar
      ref="date"
      type="single"
      @selected="getDate"
    />
  </div>
</template>

<script>
import {Field,Cell,Tag ,Popup,DatetimePicker} from 'vant'
import { mapGetters } from 'vuex'
import { formatDate } from 'Utils/dateUtil'
// import tripType from 'Common/tripType'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import carFlights from 'Views/Car/carQuery/flight/carFlights'
import queryFlights from 'Views/Car/carQuery/flight/queryCarFlights'
import { localget, localset } from 'Utils/storage.js'

const newdate=formatDate(new Date())

export default {
  name: 'CheckIn',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    // tripType,
    ldTabbar,
    ldButton,
    carFlights,
    queryFlights,
    ldCalendar: () => import('Common/ldCalendar'),
  },
  data () {
    return {
      seatTypeData:[{name:'不限',checked:true},{name:'第一排',checked:false},{name:'第二排',checked:false},{name:'安全出口',checked:false}],
      seatTypeData1:[{name:'不限',checked:true},{name:'靠窗',checked:false},{name:'中间',checked:false},{name:'过道',checked:false}],
      flightNo:'',
      departDate:newdate.date+' '+newdate.hm,// 最终传给接口的值  2020-02-02 15：20
      expiryDate: newdate.date,//传给日期控件默认日期  2020-02-02
      dateStr:newdate.monDay+' '+newdate.week,// 页面显示日期  格式 1月1日 星期一 15：20 出发
      hm:'', //起飞时间 15：20 
      minDate: new Date(),
      serverAirportNameStr:'',
      serverAirportName :'',
      myflt:false,
      myFlightData: [], //航班列表
      relateOrder:'',
      international:1,
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      searchInfo: 'checkIn/searchInfo',
      flightInfo: 'checkIn/flightInfo',
      travelerList: 'checkIn/travelerList',
      productInfo:'checkIn/productInfo',
    }),
  },
  created () {
    try {
      let historyLog=localget('_historyLog')||{}
      if(historyLog.checkIn){
        Object.assign(this,historyLog.checkIn)
        // if(this.flightNo){
        // 	this.flight()
        // }
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods:{
    flight(){
      this.$api['carQuery/queryFlightByHbh']({
        departTime: this.departDate,
        flightNo: this.flightNo,
      }).then((res) => {
        let cache = res.data || {}
        let list = cache.list || []
        let obj=list[0]||{}
        this.serverAirportName =obj.departAirportName||''
        this.serverAirportNameStr= obj.departCityName +'-'+this.serverAirportName
        this.serverAirportCode=obj.departAirport
        this.international=obj.international||1
        this.$store.commit('checkIn/searchInfo',obj)
        if (obj.departAirportName) {
          this.query()
        } else {
          this.$toast('没有查询到航班数据!')
        }
      }).catch(res=>{
        console.log(res)
      })
    },
    showDate(){
      this.$refs.date.toggle({defaultDate:this.expiryDate})
    },
    getDate(item) {
      let dates=formatDate(item)
      this.expiryDate = dates.date
      if(this.flightNo){
        this.dateStr = dates.monDay+' '+dates.week+' '+this.hm+'出发'
        this.departDate = dates.date+' '+this.hm
      }else{
        this.departDate = dates.date+' '+dates.hm
        this.dateStr = dates.monDay+' '+dates.week
      }
    },
    inputNo(val){
      if(val){
        this.flightNo=val.toUpperCase()
        if(val.length>4){
          this.flight()
        }
      }
    },
    query(){
      this.$api['airService/checkInQuery']({
        flightNumber:this.flightNo,
        targetDate:this.departDate,
      }).then(res=>{
        this.$store.commit('checkIn/setProductInfo',res.data||{})
      })
    },
    book(){
      if(!this.flightNo){
        this.$toast('请输入航班号！')
        return
      }
      let seatType =[]
      this.seatTypeData.forEach(item=>{
        if(item.checked){
          seatType.push(item.name)
        }
      })
      this.seatTypeData1.forEach(item=>{
        if(item.checked){
          seatType.push(item.name)
        }
      })
      let params={
        serverAirportCode:this.serverAirportCode,
        serverAirportName :this.serverAirportName,
        serverAirportNameStr:this.serverAirportNameStr,
        seatType:seatType.join(','),
        flightNo:this.flightNo,
        departDate:this.departDate,
        relateOrder:this.relateOrder,
        international:this.international,
      }
      this.$store.commit('checkIn/params',params)
      try {
        let historyLog=localget('_historyLog')||{}
        historyLog.checkIn={seatTypeData:this.seatTypeData,seatTypeData1:this.seatTypeData1,...params}
        localset('_historyLog',historyLog)
      } catch (error) {
        console.log(error)
      }
                
      this.$store.commit('checkIn/searchInfo',this.productInfo)
      if(this.flightInfo.flightNo){
        this.$store.commit('checkIn/flightInfo',this.flightInfo)
      }
      this.$router.push({path:'/checkIn/edit'})
    },
    queryFlights(param,date) {
      this.myflt=false
      this.myFlightData = param
      this.toggle('myFlights',{data:param,date:date})
    },
    myFlight(name) {
      this.myflt=true
      //获取系统内机票订单
      //业务类型 1接送 2送机 不能为空
      this.$api['common/queryWcxOrder']({ ywlx: 1 }).then(res => {
        let cache = res.data || []
        cache.reverse()
        if (cache.length > 0) {
          this.myFlightData = cache
          this.toggle(name)
        } else {
          // this.toggle('queryFlights')
          this.$toast('未查询到您的航班信息')
        }
      })
    },
    getFlight(param){
      this.$store.commit('checkIn/flightInfo',this.flightInfo)
      this.relateOrder=param.orderNo
      this.flightNo=param.flightNo
      this.serverAirportName=param.departAirportName
      this.serverAirportNameStr= param.departCityName +'-'+param.departAirportName
      this.serverAirportCode=param.departAirport
      this.departDate=param.departTime
      this.hm=param.departTime.split(' ')[1]
      let dates=formatDate(param.departTime)
      this.expiryDate = dates.date
      this.dateStr = dates.monDay+' '+dates.week+' '+dates.hm+'出发'

      this.international=param.international||1
      if(this.travelerList.length==0){
        this.userInfo.empInfo.checked=true
        this.userInfo.empInfo.clkFlag=2
        this.$store.commit('checkIn/travelerList',[this.userInfo.empInfo])
      }
      this.query()
    },
    toggle(name,params) {
      this.$refs[name].toggle(params)
    },
    selected(name,index){
      if(index==0){
        if(this[name][index].checked){
          return
        }else{
          this[name][index].checked=true
          this[name].forEach((item,index)=>{
            if(index>0){
              item.checked=false
            }
          })
        }
      }else{
        this[name][index].checked=!this[name][index].checked
        if(this[name][index].checked){
          this[name][0].checked=false
        }else{
          let bl=true
          this[name].forEach((item,index)=>{
            if(index>0){
              if(item.checked){
                bl=false
              }
            }
          })
          if(bl){
            this[name][0].checked=true
          }
        }
      }
    },
    //返回
    back() {
      this.$store.commit('checkIn/CLEAR_ALL')
      this.$router.push({path:'/home'})
    },
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.checkIn{
    background-repeat: no-repeat;
    background-size: contain;
}
.top{
    padding-top: 100px;
}
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.dBtn {
    display: inline-block;
    width: 1.35rem;
    height: 0.48rem;
    line-height: 0.46rem;
    text-align: center;
    border-radius: 24px;
    border: 1px solid;
    font-size: @font-size-12;
}
</style>
